import { stringify } from "yaml";

export const CALL_DESCRIPTION_PLACEHOLDER = "请填写此技能的适用场景与调用条件。";
export function invocationDescription(frontmatter?: Record<string, unknown>): string {
  const value = frontmatter?.description;
  if (typeof value !== "string") return "";
  const text = value.trim();
  return text === CALL_DESCRIPTION_PLACEHOLDER ? "" : text;
}
export function buildSkillMarkdown(content: string, frontmatter?: Record<string, unknown>): string {
  if (!frontmatter || !Object.keys(frontmatter).length) return content || "";
  return `---\n${stringify(frontmatter)}---\n\n${content || ""}`;
}
export function skillTemplate(name: string): string {
  return buildSkillMarkdown("# 使用说明\n\n请填写技能执行步骤。", {
    name: name.trim(),
    description: CALL_DESCRIPTION_PLACEHOLDER,
  });
}
export function descriptionLengthError(value: string, limit: number): string {
  return Array.from(value.trim()).length > limit ? `描述最多允许 ${limit} 个字符` : "";
}
